import { useEffect, useRef } from 'react'

/**
 * It returns the previous value of the state  given value.
 *
 * @param value - The value that you want to track previous state.
 * @returns The previous value of the state.
 *
 * For further informations take a look at https://usehooks.com/usePrevious/.
 */
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
